import z from 'zod'
import { decimalSchema } from '../../utils/schema'

const deltaSchema = z.object({
  /** アセット名（例: ETH） */
  coin: z.string(),
  /** 資金調達率 */
  fundingRate: decimalSchema,
  /** サイズ（例: 49.1477） */
  szi: decimalSchema,
  /** トランザクション種別（例: funding） */
  type: z.string(),
  /** USDCでの金額 */
  usdc: decimalSchema,
})

const fundingHistorySchema = z.object({
  /** 取引の詳細情報 */
  delta: deltaSchema,
  /** トランザクションハッシュ */
  hash: z.string(),
  /** タイムスタンプ（ミリ秒） */
  time: z.number().int(),
})

export const responseSchema = z.array(fundingHistorySchema)
